// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","cardContainer":"cardContainer--2-JqK","addSearchCard":"addSearchCard--2bZxN","container":"container--3BnqS","cardCol":"cardCol--3FKb6"};